/* eslint-disable no-param-reassign */
import { SystemFuncArgs } from '$legacyecstatic';
import Canvas from 'editor/components/Canvas';
import Markup from 'editor/components/Markup';
import MarkupKit from 'editor/components/MarkupKit';
import Transform from 'editor/components/Transform';
import { Components } from '../components';

export const renderMarkup2Components = [Markup, MarkupKit, Canvas, Transform];

export function renderMarkup2(args: SystemFuncArgs<Components>): void {
  const { components } = args;
  const markupComp = components.get(Markup);
  const { MKMarkup, mkRenderMarkup } = components.get(MarkupKit);
  const canvasComp = components.get(Canvas);
  const transformComp = components.get(Transform);

  if (!markupComp.mkMarkup) {
    markupComp.mkMarkup = new MKMarkup(markupComp.markup.jsonBlob);
  }

  if (markupComp.hidden) return;

  const ctx = canvasComp.canvas.getContext('2d');
  if (!ctx) return;

  // NOTE: Setting the transform before every draw. Right now there is no
  //       measurable hit on performance, but this could change in the future.
  const { transform: t } = transformComp;
  ctx.setTransform(t[0], t[1], t[4], t[5], t[12], t[13]);

  mkRenderMarkup(markupComp.mkMarkup, ctx, new Map());

  // Draw dashed bbox if markup is selected.
  if (markupComp.selected) {
    const markupType = markupComp.mkMarkup.getType();

    if (
      markupType === 'Square' ||
      markupType === 'FreeText' ||
      markupComp.isPunch ||
      markupComp.isNewPunch
    ) {
      const bbox = markupComp.mkMarkup.getBBox();

      ctx.save();
      ctx.strokeStyle = 'blue';
      ctx.lineWidth = 2;
      ctx.setLineDash([4]);

      ctx.strokeRect(
        bbox.left - 4,
        bbox.bottom - 4,
        bbox.right - bbox.left + 8,
        bbox.top - bbox.bottom + 8
      );

      ctx.restore();
    }
  }
}
